import { useEffect, ReactNode } from 'react';
import { useMantineColorScheme, useComputedColorScheme } from '@mantine/core';

// Mantine owns the color scheme now. This bridge mirrors the resolved scheme onto
// the legacy `data-theme` attribute so the remaining --color-* tokens in global.css
// (and the not-yet-migrated editor) keep following light/dark. Must live inside
// <MantineProvider> (set up in index.tsx).
export function WithThemeProvider({ children }: { children: ReactNode }) {
  const computed = useComputedColorScheme('light');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', computed);
  }, [computed]);

  return <>{children}</>;
}

export function useThemeContext() {
  const { setColorScheme } = useMantineColorScheme();
  const theme = useComputedColorScheme('light');
  const toggleTheme = () => setColorScheme(theme === 'dark' ? 'light' : 'dark');
  return { theme, toggleTheme };
}
